import React from 'react';
import { Box, Typography } from '@telus-uds/components-web';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BoldLabel = styled.span`
  & * {
    font-weight: 700 !important;
  }
`;

const SelectedProducts = ({ products, label = 'Products' }) => {
  const productsText =
    products && products.length > 0 ? products.join(', ') : 'Nothing selected';

  return (
    <Box pb={6}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '4fr 8fr',
          alignItems: 'stretch',
          border: '1px solid #eaeaea',
          borderRadius: '5px',
          overflow: 'hidden'
        }}
      >
        <div style={{ background: '#f7f7f8', padding: '10px' }}>
          <BoldLabel>
            <Typography variant={{ bold: true, colour: 'brand' }}>
              {label}
            </Typography>
          </BoldLabel>
        </div>
        <div style={{ background: '#ffffff', padding: '10px' }}>
          <Typography>{productsText}</Typography>
        </div>
      </div>
    </Box>
  );
};

SelectedProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string
};

export default SelectedProducts;
